module.exports = __webpack_public_path__ + "static/maceio-fd762ed3f80b76692e129c912051d4ee.jpg";